import React from "react"
import QuestionPage from "../../templates/seo-collection/QuestionPage"

const Page = () => <QuestionPage destinationKey="tuscany" questionKey="whereToStay" locale="en" />

export default Page
